// extracted by mini-css-extract-plugin
module.exports = {"box":"forecast_box_12jmS","txtBox":"forecast_txtBox_3w_zH","noDataBox":"forecast_noDataBox_2oWx6","desc":"forecast_desc_1ibqN"};